angular.module('impactx.deliverycomplaint').controller('ComplaintAskSendToSupplierDialogCtrl', ComplaintAskSendToSupplierDialogCtrl);

ComplaintAskSendToSupplierDialogCtrl.$inject = ['$scope', '$mdDialog', 'trns', 'items'];

function ComplaintAskSendToSupplierDialogCtrl($scope, $mdDialog, trns, items)
{
    $scope.trns = trns;
    $scope.items = items;

    var ctrl = this;

    angular.forEach($scope.items, function (item) {
        const treatment = item.treatment.selected.id;
        if (treatment === 2 || treatment === 3) {
            item.sendItemToSupplier.value = false;
        }
    });
    
    ctrl.accept = function(){
        $mdDialog.hide($scope.items);
    };
    
    ctrl.closeDialog = function(event){
        $mdDialog.hide();
    };

}
